export const apiKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweEY1OEJGNEM2YjY0MzFDMkQ4MDAxOUJFNGU3ZmM1N2RERjgyOWJENjciLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYzNzUyNjk3Njc2OSwibmFtZSI6ImNhdC1wYXNzcG9ydCJ9.mPwJfO-sr4lYAuG35Jyju-RCQ4sq5tMBIPpt3wipd9g'
